<header class="topbar">
  <div class="topbar__inner">
    <a routerLink="/fleet" class="topbar__brand">
      <!-- The official Vestfrost Solutions lockup: a single-colour white vector on transparency, so
           `--vf-topbar-bg` shows through the glyphs and the compass star in the O. The bar colour is
           therefore free, as long as it stays dark enough for white to read against. width/height are
           the viewBox scaled by 10, which states the intrinsic ratio in the integers they accept. -->
      <img class="topbar__logo" src="/vestfrost-solutions-logo.svg"
           alt="Vestfrost Solutions" width="1507" height="310" />
      <!-- "Vestfrost" deliberately omitted — the wordmark above already says it. -->
      IoT Platform
    </a>

    <nav class="topbar__nav">
      <a routerLink="/fleet"          routerLinkActive="topbar__link--active" class="topbar__link">{{ 'nav_fleet' | translate }}</a>
      <a routerLink="/reports"        routerLinkActive="topbar__link--active" class="topbar__link">{{ 'nav_reports' | translate }}</a>
      <a routerLink="/administration" routerLinkActive="topbar__link--active" class="topbar__link">{{ 'nav_administration' | translate }}</a>
    </nav>

    <div class="topbar__user-wrap">
      <button class="topbar__user" (click)="togglePanel($event)" [class.topbar__user--open]="open()">
        <span class="topbar__avatar">{{ auth.claims().initials }}</span>
        {{ auth.claims().name }}
        <svg class="topbar__chevron" [class.topbar__chevron--open]="open()"
             width="12" height="8" viewBox="0 0 12 8" fill="none">
          <path d="M1 1l5 5 5-5" stroke="rgba(255,255,255,0.5)" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </button>

      @if (open()) {
        <div class="topbar__panel" (click)="$event.stopPropagation()">

          <!-- User info -->
          <div class="topbar__panel-user">
            <span class="topbar__panel-avatar">{{ auth.claims().initials }}</span>
            <div class="topbar__panel-info">
              <div class="topbar__panel-name">{{ auth.claims().name }}</div>
              <div class="topbar__panel-role">
                @if (roleLabelKey(); as key) {
                  {{ key | translate }}
                } @else {
                  {{ permissions.roleName() ?? '—' }}
                }
              </div>
            </div>
          </div>

          <div class="topbar__panel-divider"></div>

          <!-- My profile -->
          <a class="topbar__panel-link" routerLink="/profile" (click)="closePanel()">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <circle cx="8" cy="5.5" r="2.75" stroke="currentColor" stroke-width="1.5"/>
              <path d="M2.75 13.5a5.25 5.25 0 0110.5 0" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
            {{ 'user_panel_profile' | translate }}
          </a>

          <div class="topbar__panel-divider"></div>

          <!-- Language switcher -->
          <div class="topbar__panel-section">
            <div class="topbar__panel-label">{{ 'user_panel_language' | translate }}</div>
            <div class="topbar__panel-langs">
              <button class="topbar__lang-btn" [class.topbar__lang-btn--active]="currentLang() === 'da'"
                      (click)="setLang('da', $event)">
                <svg class="topbar__lang-flag" viewBox="0 0 28 20" aria-hidden="true">
                  <rect width="28" height="20" fill="#C60C30"/>
                  <rect x="8" width="4" height="20" fill="white"/>
                  <rect y="8" width="28" height="4" fill="white"/>
                </svg>
                Dansk
              </button>
              <button class="topbar__lang-btn" [class.topbar__lang-btn--active]="currentLang() === 'en'"
                      (click)="setLang('en', $event)">
                <svg class="topbar__lang-flag" viewBox="0 0 60 30" aria-hidden="true">
                  <rect width="60" height="30" fill="#012169"/>
                  <path d="M0,0 L60,30 M60,0 L0,30" stroke="white" stroke-width="6"/>
                  <path d="M0,0 L60,30 M60,0 L0,30" stroke="#C8102E" stroke-width="3"/>
                  <path d="M30,0 V30 M0,15 H60" stroke="white" stroke-width="10"/>
                  <path d="M30,0 V30 M0,15 H60" stroke="#C8102E" stroke-width="6"/>
                </svg>
                English
              </button>
            </div>
          </div>

          <div class="topbar__panel-divider"></div>

          <!-- Logout -->
          <button class="topbar__panel-logout" (click)="logout()">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M6 2H3a1 1 0 00-1 1v10a1 1 0 001 1h3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              <path d="M10 11l3-3-3-3M13 8H6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            {{ 'user_panel_logout' | translate }}
          </button>

        </div>
      }
    </div>

  </div>
</header>
